/**
 * Delivery state of the emails a work order sent its customer (#3787): the
 * "vehicle is ready" email, which carries the work order's id. The quote,
 * additional-work offer and inspection report emails have their own histories
 * beside the documents they carry.
 */
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@mui/material';
import { EmailDeliveryHistory } from '@/components/email/EmailDeliveryHistory';

export function WorkOrderEmailDeliveries({ workOrderId }: { workOrderId: string }) {
  const { t } = useTranslation('common');
  return (
    <Card variant="outlined" sx={{ my: 2 }}>
      <CardContent>
        <EmailDeliveryHistory entityType="booking" entityId={workOrderId} title={t('emailDelivery.workOrderTitle')} />
      </CardContent>
    </Card>
  );
}
